import { gql } from '../../../apollo/__generated__';

export const MY_TARGETED_USERS = gql(`
  query MyTargetedUsers($eventId: ID!) {
    myTargetedUsers(eventId: $eventId) {
      id
      firstname
      lastname
      nickname
      studies
      studyTown
      folklore
      targetCount(eventId: $eventId)
    }
  }
`);
